<template>
  <div class="diy-topbar__modal">
    <slot name="header">
      <div v-on="$listeners" class="diy-topbar__modal-title">
        <AppIcon icon="fal fa-chevron-left" />
        <AppHeading tag="h3" :text="name" />
      </div>
    </slot>
    <!-- content -->
    <div class="diy-topbar__modal-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
// Components

export default {
  name: 'TheTopbarNavbarSubmenu',

  props: {
    name: {
      type: String,
      default: 'Submenú',
    },
  },

  components: {
    AppIcon: () => import('Ui/AppIcon'),
    AppHeading: () => import('Ui/AppHeading'),
  },
}
</script>

<style scoped>
.diy-topbar__modal-title {
  display: flex;
  align-items: center;
  color: var(--c-primary);
  gap: 15px;
  width: 100%;
  min-height: 44px;
  border-radius: 4px;
  padding: 5px 20px;
  text-decoration: none;
  cursor: pointer;
  transition: var(--transition--default);
}

.diy-topbar__modal-title:hover {
  background-color: var(--c-secondary-400);
}

.diy-topbar__modal-content {
  border-top: 1px solid var(--c-secondary-400);
  padding-top: 0.625rem;
  margin-top: 0.625rem;
}

.diy-topbar__modal-title .app-icon {
  font-size: 1.25rem;
}
</style>
